import React, {createContext, useContext, useMemo } from 'react';

const EmptyWishlistValueContext = createContext({} as any);

export const useEmptyWishlistValue = () => {
    const context = useContext(EmptyWishlistValueContext);
    if(context === undefined) {
        throw new Error('useEmptyWishlistValue must be used within a EmptyWishlistValueProvider');
    }

    return context;
}

export interface EmptyWishlistValueProviderProps {
    children: React.ReactNode;
    userIsLoggedIn: boolean;
    isWishlistEmpty: boolean;
    wishlistCount: number;
}

const EmptyWishlistValueProvider: React.FC<EmptyWishlistValueProviderProps> = ({children, userIsLoggedIn, isWishlistEmpty, wishlistCount}) => {
    const [wishlistUpdated, setWishlistUpdated] = React.useState(false);
    const [currentCount, setCurrentCount] = React.useState(wishlistCount);
    const isSignInButtonVisible = !userIsLoggedIn && isWishlistEmpty;

    const emptyWishlistValueObject = useMemo(() => {
        return {
            wishlistUpdated,
            setWishlistUpdated,
            isSignInButtonVisible,
            currentCount,
            setCurrentCount
        }
    }, [isSignInButtonVisible, wishlistUpdated, currentCount]);

    return (
        <EmptyWishlistValueContext.Provider value={emptyWishlistValueObject}>
            {children}
        </EmptyWishlistValueContext.Provider>
    )
}
export default EmptyWishlistValueProvider;